import React from 'react' 
import getPerformancesIntervall from "../functions/getPerformancesIntervall"
import getDayKey from '../functions/getDayKey'
import MovieTimesPeriodeDaysItemsAccess from './MovieTimesPeriodeDaysItemsAccess'
import TranslationCont from '../General/TranslationCont'
import TranslationTimeCont from '../General/TranslationTimeCont'


//ToDo in MovieTimesPeriodeDays verwenden
const filterPeriodesDays = periodesDays => {
    const keys = Object.keys(periodesDays)
    if(keys.length > 10) {
        const filteredPeriodesDays = {}

        for (const dayKey of keys) {
            const day = periodesDays[dayKey]

            if(day.length > 0) {
                filteredPeriodesDays[dayKey] = day
            }
        }

        return filteredPeriodesDays
    } else {
        return periodesDays
    }
}


const TransPerformance = ({timeStringToday, timeStringPerformance}) => (
    timeStringToday === timeStringPerformance ? (
        <TranslationCont id="today">Heute</TranslationCont> 
    ) : (
        <TranslationTimeCont id="performanceDates" timeString={timeStringPerformance} />
    )
)

const MovieTimesPeriodeDaysAccess = ({
    timesId,
    movieTitle,
    alternativeLinks,
    today,
    timezone,
    performances,
    currentCinemaId,
    clusterCinemaOption,
    cinemas,
    activePerformanceId,
    onToggleActivePerformanceId,
}) => {
    const periodesDays = filterPeriodesDays(getPerformancesIntervall(performances, today, timezone))
    const keyToday = getDayKey(today)
    const objectKeys = Object.keys(periodesDays)
    const rowHeader = []
    const rowData = []
    const rowStyles = {
        gridTemplateColumns: `repeat(${objectKeys.length}, 1fr)`
    } 

    objectKeys.map(dayKey => {
        const key = `${timesId}_${dayKey}`

        rowHeader.push(
            <div key={`${key}_header`} role='columnheader' className="access-columnheader text-medium access-typo">
                <TransPerformance 
                    timeStringToday={keyToday}
                    timeStringPerformance={dayKey}
                />
            </div>
        )

        rowData.push(
            <div key={key} role='cell' className="access-cell">
                <MovieTimesPeriodeDaysItemsAccess
                    dayKey={dayKey}
                    alternativeLinks={alternativeLinks}
                    performances={periodesDays[dayKey]}
                    timezone={timezone}
                    currentCinemaId={currentCinemaId}
                    clusterCinemaOption={clusterCinemaOption}
                    cinemas={cinemas}
                    activePerformanceId={activePerformanceId}
                    onToggleActivePerformanceId={onToggleActivePerformanceId}
                />
            </div>
        )
    })


    return (
        <div className='access-table' role="table" aria-label={`Performances for ${movieTitle}`}>
            <div role='rowgroup'>
                <div role="row" style={rowStyles}>{rowHeader}</div>
            </div>

            <div role='rowgroup'>
                <div role="row" style={rowStyles}>{rowData}</div>
            </div>
        </div>
    )
}

export default MovieTimesPeriodeDaysAccess